export function getResultCounts(items) {
    return items.reduce(
        (counts, item) => {
            if (item.isError) {
                counts.failed += 1;
            } else {
                counts.success += 1;
            }
            return counts;
        },
        { success: 0, failed: 0 },
    );
}
